"use client";

import Image from "next/image";
import { motion } from "framer-motion";

const topImages = ["/1a.png", "/3b.jpg", "/7b.jpg", "/2a.png"];
const bottomImages = ["/3a.png", "/2a.png", "/1a.png", "/3b.jpg"];

// Componente para o slider infinito sem travamento
const InfiniteSlider = ({ images, duration, className = "" }: { 
  images: string[]; 
  duration: number; 
  className?: string; 
}) => {
  return (
    <div className={`relative w-full overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)] ${className}`}>
      <motion.div
        className="flex gap-6"
        animate={{ x: ["0%", `-${100 / 2}%`] }} // Move exatamente metade do container
        transition={{
          duration,
          repeat: Infinity,
          ease: "linear",
        }}
      >
        {[...images, ...images].map((src, i) => (
          <div
            key={i}
            className="relative w-72 h-48 flex-shrink-0 rounded-xl overflow-hidden shadow-lg border-2 border-white/20"
          >
            <Image 
              src={src} 
              alt={`Image ${i + 1}`} 
              fill 
              className="object-cover" 
            />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default function Hero() {
  return (
    <section className="relative w-full h-screen bg-black text-white overflow-hidden">
      {/* SLIDERS - AMBOS MOVENDO DA DIREITA PARA ESQUERDA SEM TRAVAR */}
      <div className="absolute inset-0 flex flex-col justify-center items-center gap-12 p-8 md:p-16 z-10">
        {/* SLIDER SUPERIOR */}
        <InfiniteSlider 
          images={topImages} 
          duration={35} 
        />
        
        {/* SLIDER INFERIOR (MAIS RÁPIDO) */}
        <InfiniteSlider 
          images={bottomImages} 
          duration={30} 
        />
      </div>

      {/* TEXTO PRINCIPAL */}
      <div className="absolute inset-0 flex flex-col justify-center items-center z-20 bg-black/70">
        <div className="text-center max-w-4xl px-4">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            A Trusted Network for Global Audiovisual{" "}
            <span className="text-yellow-500">Localization</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8">
            Connecting cultures through professional audiovisual translation services
          </p>
          
        </div>
      </div>

      {/* OVERLAY GRADIENTE */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-transparent to-black/70 z-0" />
    </section>
  );
}